module.exports = __webpack_public_path__ + "pc/static/img/act_action.01090af3.png";